/**
 * Validation utilities for custom functions
 */
export class InputValidator {

  /**
   * Error messages
   */
  static INVALID_CURRENCY_CODE = "Invalid currency code. Please provide a valid 3-letter ISO currency code.";

  /**
   * Validates if the provided string is a valid 3-letter ISO currency code
   * @param {string} currencyCode - The currency code to validate
   * @returns {boolean} - True if valid, false otherwise
   */
  static isValidCurrencyCode(currencyCode: string): boolean {
    if (!currencyCode || typeof currencyCode !== 'string') return false;
    const trimmed = currencyCode.trim();
    if (!trimmed) return false;
    // ISO 4217 currency codes are exactly 3 letters (case-insensitive)
    return /^[a-z]{3}$/i.test(trimmed);
  }

}
